// extracted by mini-css-extract-plugin
export default {"root":"LaunchpadLanes_root__ZfUkx"};